import { gql } from "graphql-request";
import graphqlClient from "./graphqlClient";

export interface User {
  uuid: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  avatar: string;
  avatarThumb: string;
  birthYear: number;
  changeEmailUuid: string;
  city: string;
  clientsCount: number;
  country: string;
  createdAt: string;
  dob: string;
  gender: string;
  id: number;
  isArchived: boolean;
  isInvitationMode: boolean;
  isSuspended: boolean;
  lastLoginAt: string;
  newEmail: string;
  organization: {
    name: string;
    id: number;
  };
  organizationId: number;
  otherProfessionalCredentials: string;
  phone: string;
}

export interface GetMeResponse {
  getMe: User;
}

const GET_ME_QUERY = gql`
  query GetMe {
    getMe {
      uuid
      email
      firstName
      lastName
      fullName
      avatar
      avatarThumb
      birthYear
      changeEmailUuid
      city
      clientsCount
      country
      createdAt
      dob
      gender
      id
      isArchived
      isInvitationMode
      isSuspended
      lastLoginAt
      newEmail
      organization {
        name
        id
      }
      organizationId
      otherProfessionalCredentials
      phone
    }
  }
`;

export async function getMe(token?: string | null): Promise<User> {
  const response = await graphqlClient.request<GetMeResponse>(GET_ME_QUERY, undefined, token);
  return response.getMe;
}
